<template>
    <div>
  
      <form action="https://yuechuang.eos-wuxi-1.cmecloud.cn" method="post" enctype="multipart/form-data">
    <!-- action 是具体要上传的地址 -->
  
    上传后文件（Object）名:
    <input type="input" name="key" value="cj20230821003.jpg" style="width: 400px"/><br/><br/>
  
    ACL：
    <input type="input" name="acl" value="public-read-write" placeholder="文件 ACL" style="width: 400px"/><br/><br/>
  
    Content-Type:
    <input type="input" name="Content-Type" value="image/jpg" placeholder="文件类型" style="width: 400px"/><br/><br/>

    X-Amz-Credential：
    <input type="text" name="X-Amz-Credential"  value="1U04U6B1SL3IJNAOIAMN/20230821/us-east-1/s3/aws4_request" placeholder="X-Amz-Credential，从后端程序返回中获取" style="width: 400px"/><br/><br/>

    X-Amz-Algorithm：
    <input type="text" name="X-Amz-Algorithm" value="AWS4-HMAC-SHA256" placeholder="X-Amz-Algorithm， 从后端程序返回中获取" style="width: 400px"/><br/><br/>

    X-Amz-Date：
    <input type="text" name="X-Amz-Date" value="20230821T080734Z" placeholder="X-Amz-Date 从后端程序返回中获取" style="width: 400px"><br/><br/>

    Policy：
    <input type="text" name="Policy" value="eyJleHBpcmF0aW9uIjoiMjAyMy0wOC0yMVQwOTowNzozNC41MDVaIiwiY29uZGl0aW9ucyI6W3sieC1hbXotZGF0ZSI6IjIwMjMwODIxVDA4MDczNFoifSx7ImFjbCI6InB1YmxpYy1yZWFkLXdyaXRlIn0seyJidWNrZXQiOiJ5dWVjaHVhbmcifSxbInN0YXJ0cy13aXRoIiwiJGtleSIsImNqMjAyMzA4MjEwMDMuanBnIl0sWyJzdGFydHMtd2l0aCIsIiRDb250ZW50LVR5cGUiLCJudWxsIl0seyJ4LWFtei1hbGdvcml0aG0iOiJBV1M0LUhNQUMtU0hBMjU2In0seyJ4LWFtei1jcmVkZW50aWFsIjoiMVUwNFU2QjFTTDNJSk5BT0lBTU4vMjAyMzA4MjEvdXMtZWFzdC0xL3MzL2F3czRfcmVxdWVzdCJ9XX0=" placeholder="Policy 从后端程序返回中获取" style="width: 400px"/><br/><br/>

    X-Amz-Signature：
    <input type="text" name="X-Amz-Signature" value="bfc303973aa58c68e090656c192e921d8ac472e018b181444b5c5a78864f2072" placeholder="X-Amz-Signature 从后端程序返回中获取" style="width: 400px"/><br/><br/>

    选择文件（Object）
    <input type="file" name="file" style="width: 400px"/> <br/><br/>
    <input type="submit" name="submit" value="上传到 EOS" style="width: 400px"/><br/><br/>
  </form>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        
  
      };
    },
  
    watch: {
      
    },
  
    methods: {
      
    },
  
    created() {
    }
  };
  </script>
  
  <style scoped>
  </style>
  


// WEBPACK FOOTER //
// src/views/testfile.vue